import { mediaItems } from '@/mocks/siteData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            视频拆解
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">逐帧分析影视争议，用画面说话</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-48 md:h-52 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 bg-primary-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs px-2 py-1 bg-foreground-950/70 text-background-50 rounded-md whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 bg-accent-500 text-background-50 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">{item.desc}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}